import axios from 'axios';
import cookie from 'js-cookie';
import { Notification } from '@alifd/next';
const axiosServer = axios.create();
const handlerError = ({ message = '', desc = '', }) => {
    Notification.open({
        type: 'error',
        title: `请求错误 ${message}`,
        content: desc,
    });
};
axiosServer.interceptors.request.use(async (config) => {
    config.headers.Authorization = cookie.get('Authorization');
    return config;
}, (err) => {
    Notification.open({
        type: 'error',
        title: `请求错误 `,
        content: err.message,
    });
    return Promise.reject(err);
});
axiosServer.interceptors.response.use((response) => {
    if (response.data && response.data.retStatus === false) {
        const { retCode, retMsg, traceId } = response.data;
        handlerError({
            code: retCode,
            message: retMsg,
            desc: `错误跟踪ID: ${traceId}`,
        });
        return Promise.reject(response.data);
    }
    return response.data;
}, (err) => {
    Notification.open({
        type: 'error',
        title: '请求错误',
        content: err.message,
    });
    return Promise.reject(err);
});
export default axiosServer;
